import type { Env } from './types';

export const getStaticFilesURL = (env: Env, path: string, port = '3001') => {
  const ENVS = {
    development: `http://localhost:${port}`,
    qa: 'https://static-files.public.shared.qa.noths.com/webapps/shared',
    production: 'https://static-files.notonthehighstreet.com/webapps/shared',
  };
  return `${ENVS[env]}/${path}`;
};
